var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles,attrs:{"id":"app"}},[(_vm.isFetching)?_c('Loader'):[_c('router-view'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }